import { industries } from "@/lib/content";

export const defaultTestimonials = [
  {
    quote:
      "KS Lau & Co has given me the platform to learn, grow and take on new challenges. The supportive team and leaders truly invest in your development and celebrate your success.",
    name: "Jia Wen",
    role: "Audit Senior",
    image:
      "/__l5e/assets-v1/9b2d3812-fac2-4f0d-9582-3c4b0e0ebf51/ksl-testimonial-jia-wen.jpg",
  },
  {
    quote:
      "From day one, I was trusted with meaningful work and partnered with mentors who genuinely care. The exposure across industries has accelerated my growth more than I imagined.",
    name: "Wei Han",
    role: "Tax Associate",
    image:
      "/__l5e/assets-v1/aa973e66-f440-403b-84b2-c6a2fd44a067/wei-han-portrait.jpg",
  },
] as const;

export function defaultWhoWeServeItems() {
  return industries.map((item) => ({
    name: item.name,
    body: item.body,
    image: item.image,
  }));
}
